<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="교육안내" tabActive="갤러리" bg="/images/sub/sub-visual3.jpg">
                <template #tit>교육안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>갤러리</template>

            <board-list />
            <!-- <router-view name="board" code="" skin="gallery" hide-write-button v-bind="{ category }" /> -->
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import BoardList from "@/components/client/board/skin/gallery/list.vue";

export default {
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        BoardList,
    },
    computed: {
        category() {
            return this.$route.query.category || undefined;
        },
    },
};
</script>
